module.exports = __webpack_public_path__ + "static/img/bg-tr.ac34c593.webp";